.industry-section {
  --header-offset: 5rem;
  --body: calc(100svh - var(--header-offset) - 116px);
  --row-h: clamp(38px, calc(var(--body) * 0.062), 54px);

  position: relative;
  width: 100%;
  padding: 38px 0 5vh;
  overflow: hidden;
  background: #faf8f7;
  color: #222222;
}

.industry-inner {
  width: min(100% - 96px, 1440px);
  min-width: 0;
  margin-inline: auto;
}

.industry-heading-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) clamp(260px, 20vw, 340px);
  align-items: start;
  gap: 48px;
  margin-bottom: 48px;
}

.industry-heading-content,
.industry-intro {
  min-width: 0;
}

.industry-heading-content {
  container-type: inline-size;
}

.industry-eyebrow {
  display: flex;
  align-items: center;
  gap: 13px;
  margin-bottom: 24px;
  color: #333333;
  font-family: "JetBrains Mono", monospace;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.16em;
  line-height: 1.4;
  text-transform: uppercase;
}

.industry-eyebrow-dot {
  flex: 0 0 7px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #ff6b00;
}

.industry-title {
  max-width: 100%;
  margin: 0;
  color: #222222;
  font-family: "Sora", sans-serif;
  font-size: clamp(38px, 4.2vw, 66px);
  font-weight: 600;
  letter-spacing: -0.065em;
  line-height: 1.05;
}

.industry-title-accent {
  color: #ff6b00;
}

.industry-description {
  margin: 29px 0 0;
  color: #55565a;
  font-family: "DM Sans", sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.8;
}

.industry-metric {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.industry-metric strong {
  color: #222222;
  font-family: "Sora", sans-serif;
  font-size: clamp(28px, 2.8vw, 40px);
  font-weight: 600;
  letter-spacing: -0.06em;
  line-height: 1;
}

.industry-metric span {
  color: #77777a;
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
}

.industry-showcase {
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(320px, 1fr);
  align-items: stretch;
  gap: clamp(24px, 3vw, 40px);
}

.industry-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 clamp(18px, 2vw, 28px);
  min-width: 0;
  align-content: start;
}

.industry-list-column {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.industry-list-item {
  position: relative;
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) 18px;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: var(--row-h);
  padding: 6px 0;
  border: 0;
  border-bottom: 1px solid #d9d3ce;
  background: transparent;
  color: #222222;
  text-align: left;
  cursor: pointer;
  transition: color 220ms ease, border-color 220ms ease;
  text-decoration: none;
}

.industry-list-item:first-child {
  border-top: 1px solid #d9d3ce;
}

.industry-list-number {
  color: #ff6b00;
  font-family: "JetBrains Mono", monospace;
  font-size: 11px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.industry-list-name {
  min-width: 0;
  color: #222222;
  font-family: "DM Sans", sans-serif;
  font-size: clamp(11.5px, 0.9vw, 13px);
  font-weight: 600;
  line-height: 1.4;
  transition: color 220ms ease, transform 220ms ease;
}

.industry-list-arrow {
  width: 15px;
  height: 15px;
  color: #77777a;
  opacity: 0;
  transform: translateX(-4px);
  transition: opacity 220ms ease, transform 220ms ease, color 220ms ease;
}

.industry-list-item:hover .industry-list-name,
.industry-list-item:focus-visible .industry-list-name,
.industry-list-item.is-active .industry-list-name {
  color: #ff6b00;
}

.industry-list-item:hover .industry-list-number,
.industry-list-item:focus-visible .industry-list-number,
.industry-list-item.is-active .industry-list-number {
  color: #000000;
}

.industry-list-item:hover .industry-list-arrow,
.industry-list-item:focus-visible .industry-list-arrow,
.industry-list-item.is-active .industry-list-arrow {
  color: #ff6b00;
  opacity: 1;
  transform: translateX(0);
}

.industry-list-item.is-active {
  border-bottom-color: #ff6b00;
}

.industry-list-item.is-active .industry-list-name {
  transform: translateX(4px);
}

.industry-list-item:focus-visible,
.industry-control:focus-visible {
  outline: 2px solid #ff6b00;
  outline-offset: 2px;
}

.industry-feature-card {
  position: relative;
  isolation: isolate;
  min-width: 0;
  min-height: 320px;
  overflow: hidden;
  border: 1px solid #e8e4e1;
  border-radius: 14px;
  background: #25282b;
}

.industry-feature-link {
  position: absolute;
  inset: 0;
  display: block;
  color: inherit;
  text-decoration: none;
  z-index: 0;
}

.industry-feature-placeholder {
  z-index: 0;
}

.industry-feature-shade {
  z-index: 1;
}

.industry-feature-content {
  z-index: 2;
}

.industry-feature-controls {
  z-index: 3;
}

.industry-feature-image,
.industry-feature-placeholder,
.industry-feature-shade {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.industry-feature-image {
  z-index: -2;
  object-fit: cover;
  transition: transform 700ms cubic-bezier(0.2, 0.7, 0.2, 1);
  animation: industry-fade 450ms ease both;
}

.industry-feature-card:hover .industry-feature-image {
  transform: scale(1.035);
}

.industry-feature-image--prev {
  z-index: -3;
  animation: none;
}

.industry-feature-placeholder {
  z-index: -2;
  display: grid;
  place-items: center;
  background:
    radial-gradient(ellipse at 72% 28%, rgba(255, 107, 0, 0.18), transparent 38%),
    linear-gradient(145deg, #33383d 0%, #17191b 65%, #0e0f10 100%);
}

.industry-placeholder-mark {
  color: rgba(255, 255, 255, 0.06);
  font-family: "Sora", sans-serif;
  font-size: clamp(100px, 16vw, 220px);
  font-weight: 600;
  letter-spacing: -0.1em;
}

.industry-feature-shade {
  z-index: -1;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.02) 35%, rgba(0, 0, 0, 0.78) 100%);
}

.industry-feature-content {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: clamp(20px, 2.4vw, 32px);
  color: #ffffff;
}

.industry-feature-copy {
  max-width: calc(100% - 100px);
  animation: industry-fade 450ms ease both;
}

@keyframes industry-fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}



.industry-feature-title {
  margin: 0;
  color: #ffffff;
  font-family: "Sora", sans-serif;
  font-size: clamp(20px, 2vw, 30px);
  font-weight: 600;
  letter-spacing: -0.045em;
  line-height: 1.15;
  text-wrap: balance;
}

.industry-feature-detail {
  margin-top: 5px;
  color: rgba(255, 255, 255, 0.88);
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  line-height: 1.5;
}

.industry-feature-controls {
  position: absolute;
  right: clamp(16px, 2vw, 24px);
  bottom: clamp(16px, 2vw, 24px);
  display: flex;
  gap: 10px;
}

.industry-control {
  display: grid;
  width: 44px;
  height: 44px;
  place-items: center;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: #333333;
  cursor: pointer;
  transition: background-color 220ms ease, color 220ms ease, border-color 220ms ease, transform 220ms ease;
}

.industry-control svg {
  width: 18px;
  height: 18px;
}

.industry-control:hover {
  transform: translateY(-2px);
}

.industry-control-next {
  border-color: #ff6b00;
  background: #ff6b00;
  color: #ffffff;
}

.industry-control-next:hover {
  border-color: #db4e20;
  background: #db4e20;
}

@media (max-width: 1280px) {
  .industry-showcase {
    grid-template-columns: minmax(0, 1.2fr) minmax(300px, 1fr);
  }

  .industry-list-item {
    grid-template-columns: 26px minmax(0, 1fr) 16px;
    gap: 8px;
  }
}

@media (max-width: 1200px) {
  .industry-heading-row {
    grid-template-columns: minmax(0, 1fr);
    gap: 20px;
    margin-bottom: 36px;
  }

  .industry-intro {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px 40px;
  }

  .industry-description {
    flex: 1 1 320px;
    max-width: 560px;
    margin-top: 0;
  }

  .industry-metric {
    margin-top: 0;
  }
}

@media (max-width: 1024px) {
  .industry-section {
    --row-h: 52px;
  }

  .industry-inner {
    width: calc(100% - 64px);
  }

  .industry-description {
    font-size: 14px;
  }

  .industry-showcase {
    grid-template-columns: minmax(0, 1fr);
    gap: 28px;
  }

  .industry-feature-card {
    order: -1;
    min-height: 0;
    max-height: 420px;
    aspect-ratio: 2 / 1;
  }

  .industry-list-name {
    font-size: 13px;
  }
}

@media (max-width: 700px) {
  .industry-section {
    padding: 32px 0;
  }

  .industry-inner {
    width: calc(100% - 28px);
  }

  .industry-heading-row {
    gap: 10px;
    margin-bottom: 20px;
  }

  .industry-eyebrow {
    gap: 10px;
    margin-bottom: 12px;
    font-size: 10px;
  }

  .industry-title {
    font-size: clamp(32px, 9vw, 48px);
    line-height: 1.1;
    letter-spacing: -0.055em;
  }

  .industry-break {
    display: none;
  }

  .industry-intro {
    display: block;
  }

  .industry-description {
    max-width: 460px;
    margin-top: 0;
    font-size: 13.5px;
    line-height: 1.65;
  }

  .industry-metric {
    gap: 8px;
    margin-top: 12px;
  }

  .industry-metric strong {
    font-size: 28px;
  }

  .industry-metric span {
    font-size: 13px;
  }

  .industry-showcase {
    gap: 16px;
  }

  .industry-feature-card {
    max-height: none;
    aspect-ratio: 4 / 3;
    border-radius: 12px;
  }

  .industry-feature-content {
    padding: 16px;
  }

  .industry-feature-copy {
    max-width: calc(100% - 88px);
  }

  .industry-feature-title {
    font-size: 19px;
  }

  .industry-feature-detail {
    margin-top: 3px;
    font-size: 12.5px;
    line-height: 1.45;
  }

  .industry-feature-controls {
    right: 12px;
    bottom: 12px;
    gap: 8px;
  }

  .industry-control {
    width: 40px;
    height: 40px;
  }

  .industry-list {
    gap: 0 16px;
  }

  .industry-list-item {
    grid-template-columns: 24px minmax(0, 1fr) 14px;
    gap: 6px;
  }

  .industry-list-number {
    font-size: 10px;
  }

  .industry-list-name {
    font-size: 12px;
  }

  .industry-list-arrow {
    width: 13px;
    height: 13px;
  }
}

@media (max-width: 600px) {
  .industry-section {
    --row-h: 44px;
  }

  .industry-list {
    grid-template-columns: minmax(0, 1fr);
  }

  .industry-list-column + .industry-list-column .industry-list-item:first-child {
    border-top: 0;
  }

  .industry-list-item {
    grid-template-columns: 28px minmax(0, 1fr) 16px;
    gap: 8px;
    padding: 4px 0;
  }

  .industry-list-name {
    font-size: 13px;
  }

  .industry-feature-card {
    aspect-ratio: 5 / 4;
  }
}

@media (max-width: 360px) {
  .industry-feature-copy {
    max-width: calc(100% - 76px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .industry-feature-image,
  .industry-feature-copy {
    animation: none;
  }

  .industry-feature-image,
  .industry-list-name,
  .industry-list-arrow,
  .industry-control {
    transition: none;
  }
}